export default __webpack_public_path__ + "static/media/booming.751f581a.svg";